import { render, staticRenderFns } from "./AsStampHistoryStatusListItem.vue?vue&type=template&id=4dea6162"
import script from "./AsStampHistoryStatusListItem.vue?vue&type=script&lang=js"
export * from "./AsStampHistoryStatusListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports